// extracted by mini-css-extract-plugin
export default {"icon":"AssetTypeIcon_icon__2ftgN"};